@if (visible) {
  <button mat-mini-fab color="primary" class="scroll-to-top-btn" (click)="scrollToTop()">
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
}
